import axios from 'axios';
import { MORTGAGE_FORM_REGIONS } from '@alfa-bank/site-envconfig';

import { addZero } from './helpers';
import type { IRegion, TPublishRegion } from './models';

/**
 * Преобразованного списка доступных для ипотеки регионов
 */
export const transformRegions = (regions: IRegion[]): TPublishRegion[] => {
    return (
        regions
            // фильтрация по полю enabled
            .filter(item => item.enabled)
            // сортировка по полю tabindex
            .sort((a, b) => {
                return a.tabindex - b.tabindex;
            })
            // преобразование данных
            .map(({ enabled, tabindex, ...other }) => {
                return {
                    ...other,
                };
            })
    );
};

/**
 * Получение объекта региона по id
 */
export const getRegionById = ({
    regionId,
    regions,
}: {
    regionId: TPublishRegion['id'];
    regions: TPublishRegion[];
}) => regions.find(({ id }) => id === regionId);

/**
 * Определение региона ипотеки по гео-сервису
 */
export const detectRegionFromService = async (
    regionsList: TPublishRegion[],
    requestRegion: string
) => {
    const url = `${MORTGAGE_FORM_REGIONS()}/?path.eq=${requestRegion}`;

    try {
        const { data: result } = await axios({
            method: 'get',
            url,
        });

        const regionId = addZero(3, result.data[0].regionId);

        const cities = regionsList.filter(({ regions }) => regions.includes(regionId));

        return cities[0];
    } catch (e) {
        return regionsList[0];
    }
};
